<template>
  <label
    class="image__radio-label_container choice-cta"
  >
    <input
      :checked="checked"
      :value="text"
      class="image__radio-input radio-input"
      type="radio"
      @change="$emit('change')"
    >
    <RadioBorder/>
    <div class="image__radio-label">
      <img
        :src="image"
        class="image__radio-label_image"
        alt=""
      >
    </div>
  </label>
</template>

<script>
  import RadioBorder from '@/components/RadioBorder';

  export default {
    name: 'ChoiceImage',
    components: {
      RadioBorder,
    },
    props: {
      checked: {
        type: Boolean,
        required: true,
      },
      text: {
        type: String,
        required: true,
      },
      image: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
.image__radio-label_container {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100px;
}

.image__radio-label {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100px;
    border: $radio-border-size solid $gray;
    border-radius: $global-border-radius;
}

.image__radio-label_image {
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/ChoiceImage.vue